import React, { Component } from 'react'
import './Feature.scss';

import Analysis from './analysis.svg';
import Network from './network.svg';

export default class Feature extends Component {
    render() {
        return (
            <div className="feature-bg">
                <div className="feature-container">
                    <div id="feature-section" className="feature">
                        <img alt="network" src={Network}/>
                        <div className="feature-intro">
                            <p className="feature-title">Develop your gaming identify</p>
                            <p>Whatever you play any games, GameMeet assists you to record 
                                your accomplishments and experience so that you will stand out in fields.
                            </p>
                        </div>
                    </div>
                    <div id="feature-section" className="feature">
                        <div className="feature-intro">
                            <p className="feature-title">Learn from each other</p>
                            <p>Show off your gaming skills, such as analysis, mechanic and leadership in your connections.</p>
                        </div>
                        <img alt="analysis" src={Analysis}/>
                    </div>
                </div>
            </div>
        )
    }
}
